module.exports = __webpack_public_path__ + "static/img/1.0ec45ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/1.png
// module id = raUu
// module chunks = 0